import $ from 'jquery';

$('input[name=is-another-person-order]').on('click', function () {
    const form = $('.js-checkout-form__another-form');
    if ($(this).is(':checked')) {
        form.fadeIn();
        form.css('display', 'block');
        form.find('input').map(function (){
            $(this).attr('required',true)
        })
    } else {
        form.fadeOut();
        form.css('display', 'none');
        form.find('input').map(function (){
            $(this).attr('required',false)
        })
    }
})
